import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useSite } from "@/context/SiteContext";

export const FAQSection = () => {
  const { faq } = useSite();
  const [openId, setOpenId] = useState(null);

  if (!faq || faq.length === 0) return null;

  return (
    <section id="faq" className="bg-white py-16 md:py-24" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Questions fréquentes</h2>
          <p className="text-base lg:text-lg text-gray-600">Tout ce que vous devez savoir sur nos services.</p>
        </div>
        <div className="space-y-3">
          {faq.map((item, i) => (
            <div key={item.id} className="border border-gray-200 rounded-lg overflow-hidden" data-testid={`faq-item-${i}`}>
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="font-medium text-gray-900 pr-4">{item.question}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform ${openId === item.id ? "rotate-180" : ""}`} />
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
